import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import HeatmapChart from '../components/charts/HeatmapChart';
import AreaChart from '../components/charts/AreaChart';
import DoughnutChart from '../components/charts/DoughnutChart';
import VectorMap from '../components/charts/VectorMap';

const SocialDashboard: React.FC = () => {
    const heatmapData = useMemo(() => {
        const xLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const yLabels = ['12am', '2am', '4am', '6am', '8am', '10am', '12pm', '2pm', '4pm', '6pm', '8pm', '10pm'];
        const data = yLabels.map(() =>
            xLabels.map((_, i) => {
                // Creating a peak around mid-day (index 6-7)
                const hourPeak = 80 - Math.abs(6 - i) * 10;
                return Math.max(0, hourPeak + Math.floor(Math.random() * 40));
            })
        );
        return { data, xLabels, yLabels };
    }, []);

    return (
        <>

            {/* page title */}
            <div className="container py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">Social Dashboard</h6>
                        <p className="text-secondary small">Digital Marketing Analytics Dashboard</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page">Social</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">

                {/* summary */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-6 col-md-6 col-lg-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <p className="text-secondary mb-1"><i className="bi bi-heart-fill text-theme-1 theme-red fs-12 me-1"></i> Likes</p>
                                <h5 className="mb-1">1.5k</h5>
                                <p className="text-theme-1 theme-green small">250 ~ Today</p>

                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-md-6 col-lg-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <p className="text-secondary mb-1"><i className="bi bi-chat-left-dots-fill text-theme-1 theme-orange fs-12 me-1"></i> Comments</p>
                                <h5 className="mb-1">5.9k</h5>
                                <p className="text-theme-1 theme-red small">- 250 ~ Today</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-md-6 col-lg-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <p className="text-secondary mb-1"><i className="bi bi-share-fill text-theme-1 theme-cyan fs-12 me-1"></i> Share</p>
                                <h5 className="mb-1">5.54k</h5>
                                <p className="text-theme-1 theme-green small">+8% ~ Today</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-md-6 col-lg-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <p className="text-secondary mb-1"><i className="bi bi-people-fill text-theme-1 theme-red fs-14 me-1"></i> Reach</p>
                                <h5 className="mb-1">99</h5>
                                <p className="text-theme-1 theme-green small">+80% ~ Today</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row gx-3 gx-lg-4">
                    {/* Big chart traffic flow*/}
                    <div className="col-12 col-md-12 col-lg-12 col-xl-9">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-12 col-md mb-3 mb-lg-0">
                                        <h6 className="mb-0">Traffice Flow</h6>
                                        <p className="small text-secondary">Understand your audience</p>
                                    </div>
                                    <div className="col col-md-auto">
                                        <select className="form-select w-100" data-placeholder="Select Account">
                                            <option selected>All</option>
                                            <optgroup label="Social">
                                                <option>Facebook</option>
                                                <option>Instagram</option>
                                                <option>Twitter</option>
                                            </optgroup>
                                            <optgroup label="Feed">
                                                <option>Dribbble</option>
                                                <option>Youtube</option>
                                                <option>Behance</option>
                                                <option>Blogs</option>
                                            </optgroup>
                                            <option>Referral</option>
                                        </select>
                                    </div>
                                    <div className="col-auto">
                                        <button className="btn btn-link btn-square" data-bs-toggle="tooltip" data-bs-placement="top" title="Download"><i className="bi bi-download"></i></button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body pb-0">
                                <div className="tab-content" id="myTabContent">
                                    <div className="tab-pane fade show active" id="trafic1" role="tabpanel">
                                        <div className="height-180">
                                            <AreaChart labels={['1 Feb', '2 Feb', '3 Feb', '4 Feb', '5 Feb', '6 Feb', '7 Feb', '8 Feb', '9 Feb', '10 Feb']}
                                                datasets={[
                                                    {
                                                        data: [15, 10, 30, 15, 12, 10, 20, 15, 25, 20,],
                                                        label: 'Female',
                                                        color: '#e57463',
                                                        fillColor: 'rgba(229, 116, 99, 0.5)',
                                                        borderWidth: 1,
                                                        pointBackgroundColor: '#e57463',
                                                        pointBorderColor: '#ffffff',
                                                        pointRadius: 2,
                                                        tension: 0.4,
                                                        borderColor: '#e57463',
                                                    },
                                                    {
                                                        data: [20, 15, 15, 10, 20, 15, 25, 20, 10, 30],
                                                        label: 'Male',
                                                        color: '#0049e8',
                                                        fillColor: 'rgba(0, 73, 232, 0.5)',
                                                        borderWidth: 1,
                                                        pointBackgroundColor: '#0049e8',
                                                        pointBorderColor: '#ffffff',
                                                        pointRadius: 2,
                                                        tension: 0.4,
                                                        borderColor: '#0049e8',
                                                    },
                                                ]}
                                                scalesx={true}
                                                scalesy={true}
                                                height={180} />
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="trafic2" role="tabpanel">...</div>
                                    <div className="tab-pane fade" id="trafic3" role="tabpanel">...</div>
                                </div>
                            </div>
                            <div className="card-footer pb-0">
                                <ul className="nav nav-underline " id="myTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link active px-3 px-lg-4" id="trafic1-tab" data-bs-toggle="tab" data-bs-target="#trafic1" type="button" role="tab" aria-controls="trafic1" aria-selected="true">
                                            <small className="text-secondary d-block mb-0">Engagement</small>
                                            <span className="h5 mb-0">254.0M </span>
                                            <span className="d-block text-theme-1 theme-green small">(0.73%)</span>
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link px-3 px-lg-4" id="trafic2-tab" data-bs-toggle="tab" data-bs-target="#trafic2" type="button" role="tab" aria-controls="trafic2" aria-selected="false">
                                            <small className="text-secondary d-block mb-0">Clicks</small>
                                            <span className="h5 mb-0">1.55M </span>
                                            <span className="d-block text-theme-1 theme-green small">(10.61%)</span>
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link px-3 px-lg-4" id="trafic3-tab" data-bs-toggle="tab" data-bs-target="#trafic3" type="button" role="tab" aria-controls="trafic3" aria-selected="false">
                                            <small className="text-secondary d-block mb-0">Shares</small>
                                            <span className="h5 mb-0">1.845M </span>
                                            <span className="d-block text-theme-1 theme-green small">(1.73%)</span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* traffic time*/}
                    <div className="col-12 col-md-6 col-lg-6 col-xl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3">
                                    <div className="col">
                                        <h6 className="mb-1">Traffic time</h6>
                                        <p className="text-secondary small">Here is best time for visitors</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body text-center">
                                {/* heatmap chart */}
                                <HeatmapChart
                                    className="height-260 w-100 d-block position-relative"
                                    data={heatmapData.data}
                                    xLabels={heatmapData.xLabels}
                                    yLabels={heatmapData.yLabels}
                                    height={260}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Chart traffic */}
                    <div className="col-12 col-md-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center">
                                        <h6 className="mb-0">Traffic by Genders</h6>
                                        <p className="text-secondary small">114586 users visited</p>
                                    </div>

                                </div>
                            </div>
                            <div className="card-body">
                                <div className="width-180 position-relative text-center mb-3 mb-lg-4 mx-auto">
                                    <DoughnutChart
                                        labels={['Male', 'Female', 'Other']}
                                        data={[45, 35, 20]}
                                        colors={['#c80036', '#0049e8', '#becede']}
                                        cutout="70%"
                                        height={180}
                                    />
                                    <div className="avatar avatar-140 position-absolute top-50 start-50 translate-middle rounded-circle ">
                                        <div className="w-100 lh-20">
                                            <h5 className="mb-1">29.98K</h5>
                                            <p className="text-theme-1 small theme-green">18.71 (0.73%)</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-3">
                                    <div className="col-6 text-end">
                                        <div className="row gx-3">
                                            <div className="col">
                                                <h6 className="text-dark mb-0">14000</h6>
                                                <p className="text-secondary small">Male</p>
                                            </div>
                                            <div className="col-auto">
                                                <span className="avatar avatar-40 bg-blue rounded text-white">
                                                    <i className="bi bi-gender-male h5"></i>
                                                </span>
                                            </div>
                                            <div className="col-12 mt-3">
                                                <div className="row gx-3">
                                                    <div className="col">
                                                        <p className="text-secondary small">Home</p>
                                                    </div>
                                                    <div className="col-auto">
                                                        <p className="text-green small">55%</p>
                                                    </div>
                                                </div>
                                                <div className="row gx-3">
                                                    <div className="col">
                                                        <p className="text-secondary small">Work</p>
                                                    </div>
                                                    <div className="col-auto">
                                                        <p className="text-green small">45%</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="row gx-3">
                                            <div className="col-auto">
                                                <span className="avatar avatar-40 bg-theme-1 theme-red rounded text-white">
                                                    <i className="bi bi-gender-female h5"></i>
                                                </span>
                                            </div>
                                            <div className="col">
                                                <h6 className="text-dark mb-0">13568</h6>
                                                <p className="text-secondary small">Female</p>
                                            </div>
                                            <div className="col-12 mt-3">
                                                <div className="row gx-3">
                                                    <div className="col-auto">
                                                        <p className="text-green small">73%</p>
                                                    </div>
                                                    <div className="col">
                                                        <p className="text-secondary small">Home</p>
                                                    </div>
                                                </div>
                                                <div className="row gx-3">
                                                    <div className="col-auto">
                                                        <p className="text-green small">27%</p>
                                                    </div>
                                                    <div className="col">
                                                        <p className="text-secondary small">Work</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-12 col-lg-12 col-xl-9">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3 align-items-center">
                                    <div className="col">
                                        <h6 className="mb-0">Traffic Source</h6>
                                        <p className="text-secondary small">Visitors/Users around the <b>Earth</b></p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <VectorMap height={220}></VectorMap>
                            </div>
                            <div className="card-footer">
                                <div className="row gx-3">
                                    <div className="col-6 col-md mb-3 mb-md-0">
                                        <p className="text-secondary small mb-1">Users</p>
                                        <h5>5.1K <small className="text-green"><i className=" bi bi-arrow-up vm small"></i> 12%</small></h5>
                                    </div>
                                    <div className="col-6 col-md mb-3 mb-md-0">
                                        <p className="text-secondary small mb-1">Sessions</p>
                                        <h5>6.8K <small className="text-green"><i className=" bi bi-arrow-up vm small"></i> 2.1%</small></h5>
                                    </div>
                                    <div className="col-6 col-md">
                                        <p className="text-secondary small mb-1">Bounce Rate</p>
                                        <h5>3.18% <small className="text-red"><i className=" bi bi-arrow-up vm small"></i> -4.2%</small></h5>
                                    </div>
                                    <div className="col-6 col-md">
                                        <p className="text-secondary small mb-1">Session Duration</p>
                                        <h5>1m 16s <small className="text-green"><i className=" bi bi-arrow-up vm small"></i> 3.7%</small></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* social events and music cards */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-12 col-lg-6">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body ">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-12 col-md-3 col-lg-3 col-xl-3 col-xxl-4 mb-3 mb-md-0">
                                        <figure className="coverimg rounded w-100 height-200 mb-0">
                                            <img src={asset('assets/img/adminuiux/image-2.jpg')} alt="" className="mw-100" />
                                        </figure>
                                    </div>
                                    <div className="col mb-3">
                                        <p><span className="badge badge-light text-bg-theme-1">Trending Post</span></p>
                                        <h6 className="mb-2">Learn about software and Framework. All Design and Usability practices</h6>
                                        <p className="text-secondary small mb-3">We have represented best product and template with great user experience</p>

                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <h5 className="mb-1">2,545,05</h5>
                                                <p className="text-secondary"><i className="bi bi-bullseye me-1"></i> Engaged Audience</p>
                                            </div>
                                            <div className="col-auto ms-auto">
                                                <a href="adminuiux-blogs.html" className="btn btn-link ">More...</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="card position-relative bg-theme-1 mb-3 mb-lg-4 overflow-hidden">
                            <div className="w-100 h-100 coverimg position-absolute top-0 start-0">
                                <img src={asset('assets/img/adminuiux/image-1.jpg')} alt="" />
                            </div>
                            <div className="card-header z-index-1 position-relative">
                                <div className="badge text-bg-theme-1">Trending</div>
                            </div>
                            <div className="card-body z-index-1 position-relative height-110">
                            </div>
                            <div className="card-footer z-index-1 position-relative">
                                <h6 className="mb-1">Album: Jonaatha</h6>
                                <p className="">Release: 28-08-2026</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <p><span className="badge badge-light text-bg-theme-1">Event</span></p>

                                <h6 className="text-theme-1 mb-1">Tech Event 2026</h6>
                                <p className="text-secondary"><i className="bi bi-calendar-event me-2"></i> 25-05-2026</p>
                                <p className="text-secondary small">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque eget finibus felis. </p>
                            </div>
                            <div className="card-footer">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto avatar-group">
                                        <div className="avatar avatar-30 coverimg rounded-circle">
                                            <img src={asset('assets/img/adminuiux/user-2.jpg')} alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle">
                                            <img src={asset('assets/img/adminuiux/user-3.jpg')} alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle">
                                            <img src={asset('assets/img/adminuiux/user-4.jpg')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <h5>1525K</h5>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-sm btn-theme" href="adminuiux-payment.html">Join</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row gx-3 gx-lg-4">
                    {/* Subscribe upgrade plan */}
                    <div className="col-12 col-md-6 col-lg-6 col-xxl-4">
                        <div className="card mb-3 mb-lg-4 overflow-hidden">
                            <div className="card-header">
                                <div className="row gx-3 align-items-center">
                                    <div className="col">
                                        <h6 className="mb-0">Subscribe PRO account</h6>
                                        <p className="text-secondary small">60 USD per year</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                <ul className="list-group list-group-flush border-0 bg-none">
                                    <li className="list-group-item text-secondary">
                                        <div className="row gx-3">
                                            <div className="col-auto">
                                                <i className="bi bi-check-circle text-muted"></i>
                                            </div>
                                            <div className="col-auto">
                                                Unlimited Send Money
                                            </div>
                                        </div>
                                    </li>
                                    <li className="list-group-item text-secondary">
                                        <div className="row gx-3">
                                            <div className="col-auto">
                                                <i className="bi bi-check-circle text-muted"></i>
                                            </div>
                                            <div className="col-auto">
                                                Multiple Currencies Support
                                            </div>
                                        </div>
                                    </li>
                                    <li className="list-group-item text-secondary">
                                        <div className="row gx-3">
                                            <div className="col-auto">
                                                <i className="bi bi-check-circle text-muted"></i>
                                            </div>
                                            <div className="col-auto">
                                                Unlimited Send Money
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="card-body">
                                <div className="row gx-3">
                                    <div className="col-6">
                                        <div className="form-check form-check-circle">
                                            <input className="form-check-input" type="radio" name="priceupgrade" value="" id="priceupgrade1" defaultChecked />
                                            <label className="form-check-label" htmlFor="priceupgrade1">
                                                <span className="h5">251.00 <small>USD</small></span><br />
                                                <span className="text-secondary small">5 Years <span className="text-theme-1 theme-green">13% Off</span></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-check form-check-circle">
                                            <input className="form-check-input" type="radio" name="priceupgrade" value="" id="priceupgrade2" />
                                            <label className="form-check-label" htmlFor="priceupgrade2">
                                                <span className="h5">108.00 <small>USD</small></span><br />
                                                <span className="text-secondary small">2 Years <span className="text-theme-1 theme-green">10% Off</span></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <div className="row gx-3">
                                    <div className="col">
                                        <div className="input-group ">
                                            <span className="input-group-text text-theme-1"><i className="bi bi-tag h5"></i></span>
                                            <input type="text" className="form-control" placeholder="Coupon Code" defaultValue="13DISCNEW21" />
                                            <span className="input-group-text text-theme-1 theme-green"><i className="bi bi-patch-check h5"></i></span>
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-theme" href="payment.html">Pay Now</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Income green chart card */}
                    <div className="col-12 col-md-6 col-lg-6 col-xxl-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3 align-items-center">
                                    <div className="col">
                                        <h6 className="mb-0">Male Traffics</h6>
                                        <p className="text-secondary small">Last 6 Months</p>
                                    </div>
                                    <div className="col-auto">
                                        <div className="input-group input-group-md rounded">
                                            <span className="input-group-text">
                                                <i className="bi bi-gender-male"></i>
                                            </span>
                                            <select className="form-select" aria-label="Default select example">
                                                <option>All</option>
                                                <option value="1">1-16</option>
                                                <option value="2">17-25</option>
                                                <option value="3" selected>26-55</option>
                                                <option value="4">56 - 70+</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <h5 className="mb-2">2,545 <small className="text-theme-1 theme-green"><i className="bi bi-arrow-up"></i> 108(0.73%)</small></h5>
                                <p className="mb-3 mb-lg-4"><span className="text-secondary">Age range:</span> 26-55</p>
                                <div className="height-160">
                                    <AreaChart
                                        labels={['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']}
                                        data={[12, 19, 3, 5, 2, 3, 10]}
                                        color="#08a046"
                                        height={160}
                                        scalesx={true}
                                        scalesy={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Expense red chart card */}
                    <div className="col-12 col-md-6 col-lg-6 col-xxl-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3 align-items-center">
                                    <div className="col">
                                        <h6 className="mb-0">Female Traffic</h6>
                                        <p className="text-secondary small">Last 6 Months</p>
                                    </div>
                                    <div className="col-auto">
                                        <div className="input-group input-group-md rounded">
                                            <span className="input-group-text">
                                                <i className="bi bi-gender-female"></i>
                                            </span>
                                            <select className="form-select" aria-label="Default select example">
                                                <option>All</option>
                                                <option value="1">1-16</option>
                                                <option value="2">17-25</option>
                                                <option value="3" selected>26-55</option>
                                                <option value="4">56 - 70+</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <h5 className="mb-2">4,101 <small className="text-theme-1 theme-green"><i className="bi bi-arrow-up"></i> 108 (1.83%)</small></h5>
                                <p className="mb-3 mb-lg-4"><span className="text-secondary">Age range:</span> 26-55</p>
                                <div className="height-160">
                                    <AreaChart
                                        labels={['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']}
                                        data={[12, 19, 3, 5, 2, 3, 10]}
                                        color="#e53838"
                                        height={160}
                                        scalesx={true}
                                        scalesy={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SocialDashboard;
